module.exports = __webpack_public_path__ + "img/6.0e62ade1.png";